<!-- <div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button  mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div> -->

<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{parentData.title}} [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field" style="justify-content: end;">
      <button
      
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent">
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>


</sm-misc-title-bar>
<div class="" style="margin-left: 16px;margin-right: 16px;">
<mat-form-field appearance="outline" class="me-2" *ngIf="toShowTemplate">
  <mat-label>{{ 'services.label' | translate }}</mat-label>
  <input
  [formControl]="searchString"
   
    matInput
    placeholder="Enter keyword"
    (keyup)="searchServiceData()"
  />
  <button
  
    mat-button
    *ngIf="!searchString.value"
    matSuffix
    
    aria-label="Clear"
  >
    <mat-icon>search</mat-icon>
  </button>
  <button
  mat-button
  *ngIf="searchString.value"
  matSuffix
  
  aria-label="Clear"
  (click)="reset()"
>
  <mat-icon >close</mat-icon>
</button>
</mat-form-field>
</div>

  <mat-dialog-content *ngIf="!toShowTemplate">
  
 

  <div *ngIf="!toShowTemplate">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Service name</mat-label>
        <input
 
          [(ngModel)]="serviceListData.serviceName"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [(ngModel)]="serviceListData.description"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>SAC code</mat-label>
        <input
          
          [(ngModel)]="serviceListData.sac_code"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div style="margin-bottom: 15px;">

            
        
<!--         
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop"></mat-checkbox>
            <mat-label>Shop service</mat-label>
            
         
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome"></mat-checkbox>
            <mat-label>Home service</mat-label>
                        
            <mat-checkbox value="virtual" (change)="change($event)" ></mat-checkbox>
            <mat-label>Virtual service</mat-label> -->

               
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop" *ngIf="shop_status != '2'"></mat-checkbox>
            <mat-label *ngIf="shop_status != '2'">Shop service</mat-label>
            
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome" *ngIf="home_status != '2'"></mat-checkbox>
            <mat-label *ngIf="home_status != '2'">Home service</mat-label>
            
            <mat-checkbox value="virtual" (change)="change($event)" [checked]="isVirtual" *ngIf="virtual_status != '2'"></mat-checkbox>
            <mat-label *ngIf="virtual_status != '2'">Virtual service</mat-label>
            
        
    </div>
    
    <div *ngIf="isShopSpecific == true">
        <mat-form-field appearance="outline">
          <mat-label>Shop rate</mat-label>
          <input  smDecimalOnly  type="number"
          [(ngModel)]="serviceListData.shop_rate"
          matInput
        
        />
         
        </mat-form-field>
    </div>
    <div *ngIf="isHomeSpecific == true">
      <mat-form-field appearance="outline">
        <mat-label>Home rate</mat-label>
        <input  smDecimalOnly  type="number"
        [(ngModel)]="serviceListData.home_rate"
        matInput
      
      />
        
      </mat-form-field>
  </div>
  <div *ngIf="isVirtualSpecific == true">
    <mat-form-field appearance="outline">
      <mat-label>Virtual rate</mat-label>
      <input 
      [(ngModel)]="serviceListData.virtualRate"
       smDecimalOnly  type="number"
      matInput
    
    />
      
    </mat-form-field>
</div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Approx time(in minutes)</mat-label>
        <input smNumericOnly 
          [(ngModel)]="serviceListData.approxTime"
          matInput

        />
       
      </mat-form-field>
    </div>
     <div style="margin-bottom: 10px;">
        <mat-label>Set as membership package</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChangeForOnline($event)" [checked]="isOnlineAvailable"></mat-slide-toggle>
      <br><br>
        <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div style="margin-bottom: 10px;">
        <mat-label>Enable Discount</mat-label>
        <mat-slide-toggle style="    margin-left: 20px;
        position: relative;
        top: 2px;
    " class="share" (change)="onToggleChange($event)" [checked]="isDiscountApplicable"></mat-slide-toggle>
        <br><br>
<!-- 
        <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes" class="radlabel">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no" class="radlabel">No</label> -->

    </div>
    <div *ngIf="serviceListData.discountStatus == '1'" style="margin-bottom: 10px;">
        <mat-label>Discount type</mat-label>
        <br><br>

        <input type="radio" id="percent" name="discountType" [checked]="isPercent == true" value="percent" (click)="discType($event)">
        <label for="percent" class="radlabel">Percent</label>
        <input type="radio" id="amount" name="discountType" [checked]="isAmount == true" value="amount" (click)="discType($event)">
        <label for="amount" class="radlabel">Amount</label>

    </div>
    <div *ngIf="serviceListData.discountStatus == '1'">
        <mat-form-field appearance="outline">
          <mat-label>Discount Amount</mat-label>
          <input   smDecimalOnly  type="number"
            [(ngModel)]="serviceListData.discountAmount"
            matInput
  
          />
         
        </mat-form-field>
      </div>
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="margin-bottom: 10px;">
      <mat-label>Enable tax</mat-label>
      <mat-slide-toggle style="    margin-left: 20px;
      position: relative;
      top: 2px;
  " class="share" (change)="onToggleChangeForTax($event)" [checked]="isTaxApplicable"></mat-slide-toggle>
    <br><br>
      <!--         <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
      <label for="yes" class="radlabel">Yes</label>
      <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
      <label for="no" class="radlabel">No</label> -->

  </div>
    <!-- [(value)]="selectedView" [(ngModel)]="selectedView" (ngModelChange)="changeView()" -->
    <div *ngIf="isTaxApplicable && taxSlabData.length > 0">
      <mat-form-field appearance="outline">
         <mat-select [(value)]="selectedSlab" [(ngModel)]="selectedSlab" class="w-100">
                     <mat-option value="default" >
                       Select a tax
                     </mat-option>
                     <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                       {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                     </mat-option>
                    
                   </mat-select>
      </mat-form-field>
     </div>
     <div *ngIf="isTaxApplicable && taxSlabData.length == 0">
      <p>Tax not configured yet. <a href="javascript:void(0)" (click)="configureTax()">Click to configure</a></p>
     </div>
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </div>
  </mat-dialog-content>

  <mat-dialog-content *ngIf="toShowTemplate">
    <div class="row" *ngIf="serviceList.length>0">
        <div class="col-sm-4" *ngFor="let item of serviceList">
            <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                </div>
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.imgUrl && item.imgUrl != 'null'">
                                    <img [src]="item.imgUrl">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.imgUrl || item.imgUrl == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                                <h3>{{item.serviceName}}</h3>
                                <p class="elips_cls">{{
                                  item.description
                                }}
                                </p>
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <!-- <p style="margin-top: 10px;">Approx Time: {{item.approxTime}} minutes
                                </p> -->
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                        <div class="addmore_btn" *ngIf="item.selected">
                  <button mat-flat-button color="accent" (click)="onSelectNext()"><mat-icon>add</mat-icon>  Add this </button>
              </div>
                </div>
            </div>
            
        </div>
        
        <div *ngIf="datalength > serviceList.length" style="text-align: center;">
          <button style="width: 50%; border-radius: 50px;" mat-flat-button color="accent" (click)="seeMore()"> See more</button>
        </div>

    </div>

    <!-- placeholder and loder -->
<div class="row" *ngIf="sloader">
        <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
          <p>Loading service templates</p>
        </div>
      </div>
      <div class="row" *ngIf="!sloader && serviceList.length == 0">
        <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <div style="margin-bottom: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><switch><g><path d="M100.5 512c-13.81.001-25.416-10.824-26.205-24.779L52.429 100.43c-.396-7.003 1.959-13.742 6.632-18.974 4.672-5.232 11.103-8.332 18.105-8.728l39.094-2.21V26.261C116.26 11.781 128.04 0 142.521 0h256.382c1.334 0 2.613.533 3.553 1.481l55.711 56.252a5.003 5.003 0 0 1 1.447 3.519v373.692a5 5 0 0 1-5 5H415.52l2.776 49.124a5 5 0 0 1-4.71 5.274l-311.589 17.615c-.5.029-1 .043-1.497.043zm15.76-431.466-38.529 2.178a16.156 16.156 0 0 0-11.212 5.404 16.15 16.15 0 0 0-4.105 11.749L84.28 486.656c.506 8.952 8.216 15.827 17.153 15.317L408.03 484.64l-2.526-44.696H142.521c-14.48 0-26.261-11.78-26.261-26.261zM142.521 10c-8.966 0-16.261 7.295-16.261 16.261v387.422c0 8.966 7.295 16.261 16.261 16.261h307.093V66.252h-45.035c-5.887 0-10.676-4.789-10.676-10.675V10zm261.382 7.154v38.423c0 .372.303.675.676.675h38.046zm-161.876 358h-43.042c-10.387 0-18.837-8.45-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.838 8.837 8.838h43.042c4.873 0 8.838-3.965 8.838-8.838v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.404H287.541c-2.762 0-5-2.238-5-5s2.238-5 5-5h103.186c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-175.524-3.183a4.983 4.983 0 0 1-3.479-1.409l-7.845-7.599a5 5 0 0 1-.111-7.069 4.998 4.998 0 0 1 7.069-.112l4.338 4.202 14.971-14.73a4.998 4.998 0 0 1 7.071.058 5 5 0 0 1-.058 7.071l-18.45 18.153a4.99 4.99 0 0 1-3.506 1.435zm115.424-21.335h-43.086c-2.762 0-5-2.238-5-5s2.238-5 5-5h43.086c2.762 0 5 2.238 5 5s-2.238 5-5 5zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.838v-36.614c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.388-8.451 18.838-18.838 18.838zm-43.042-64.289c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837v-36.614c0-4.873-3.965-8.837-8.838-8.837zm191.742 44.403H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.182a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.336h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10zm-88.6-73.634h-43.042c-10.387 0-18.837-8.451-18.837-18.837V83.627c0-10.387 8.45-18.837 18.837-18.837h43.042c10.388 0 18.838 8.45 18.838 18.837v36.614c0 10.387-8.451 18.838-18.838 18.838zm-43.042-64.288c-4.873 0-8.837 3.964-8.837 8.837v36.614c0 4.873 3.964 8.837 8.837 8.837h43.042c4.873 0 8.838-3.964 8.838-8.837V83.627c0-4.873-3.965-8.837-8.838-8.837h-43.042zM390.727 119.1H287.541a5 5 0 1 1 0-10h103.186a5 5 0 1 1 0 10zm-175.524-3.089a4.983 4.983 0 0 1-3.479-1.409l-7.844-7.599a5 5 0 0 1 6.959-7.182l4.337 4.203 14.971-14.729a5 5 0 1 1 7.013 7.128l-18.45 18.153a4.99 4.99 0 0 1-3.507 1.435zm115.424-21.242h-43.086a5 5 0 1 1 0-10h43.086a5 5 0 1 1 0 10z" fill="#7e7e7e" opacity="1" data-original="#000000"></path></g></switch></g></svg>
        </div>
        <p>No service templates to show</p>
      </div>
      </div>

  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowTemplate">
    <div class="mer_fft">
    <button mat-button (click)="back()">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !serviceListData.serviceName ||
        !serviceListData.description ||
        !serviceListData.approxTime ||
        priceCheker() ||
        discountChecker()
      "
      (click)="onPost()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </div>
  </mat-dialog-actions>


  <!-- <mat-dialog-actions align="end" *ngIf="toShowTemplate">
    <div class="mer_fft">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedserviceList.length == 0"
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Next
    </button>
    </div>
  </mat-dialog-actions> -->
  